import * as yup from "yup";
import { duplicateEmailMess, duplicateNameMess, emailSchema, nameSchema, passwordSchema } from "./BaseSchema";

export const SignSchema = (fields) => {
  const { email, name } = fields;

  return yup.object().shape({
    email: emailSchema.required().test("server", duplicateEmailMess, function (value) {
      return value !== email;
    }),
    name: nameSchema.test("server", duplicateNameMess, function (value) {
      if (!value) return true;
      return value !== name;
    }),
    password: passwordSchema.required(),

    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required(),
  });
};

export const LoginSchema = (fields) => {
  const { email: em, password: pass } = fields;
  return yup
    .object()
    .shape({
      email: emailSchema.required(),
      password: passwordSchema.required(),
    })
    .test("server", "check Your password or Your Email", function (value) {
      const { email, password } = value;
      if (email === em && password === pass) {
        return false;
      }
      return true;
    });
};
